<template>
  <div class="toast_container">
      <div class="toast" >
          <section class="toast_infos">
              <img class="toast_icon" src="/img/validation-carousel/circle-success-icon.svg" />
              <span id="toast_text">Código de ativação copiado com sucesso!</span>

              <div class="close_toast_icon" @click="closeToast">
                  <img src="/img/validation-carousel/x-close.svg" alt="Fechar"/>
              </div>
          </section>
      </div>
      
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import { mapGetters, mapState } from 'vuex';

  export default Vue.extend({
      
      data() {
          return {
              time: 4000,
              close: null,
              isVisible: false,
              message: ""
          }
      },
      mounted() {
          //Timeout para chamar o metodo que fecha o toast após um determinado tempo
          this.close = setTimeout(() => {                
              this.time = this.time - 4000;
          }, 4000);
      },
      computed:{
          ...mapState([
              'accessibilityActive'
          ]),
          ...mapGetters([
          ])
      },
      watch: {
        toastInfos() {
            //Reiniciando timer de exibição do toast
            clearInterval(this.close)
            this.time = 4000;

            this.close = setTimeout(() => {                
                this.time = this.time - 4000;
            }, 4000);
        },
        time() {
            //Executando close do toast após 4s
            if(this.time == 0)
                this.closeToast()
        }
      },
      methods: {
          showToast(message) {
            this.message = message;
            this.isVisible = true;

            // Hide the toast after a certain duration (e.g., 3 seconds)
            setTimeout(() => {
              this.isVisible = false;
            }, 3000);
          },
          //Metodo para alterar o estado da propriedade definida no store, fechando o toast
          closeToast() {
            this.$emit("closetoast");
            //clearInterval(this.close)
          },
      }
  })
</script>

<style lang="scss" scoped>
.toast_container {
  width: 100%;
  display: flex;
  justify-content: center;
}
.toast {
  position: fixed;
  top: 24px;
  width: 327px;
  background: #EDFAE0;
  border-radius: 16px;
  z-index: 5000;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 1.625rem 0.75rem 1.625rem 1.5rem;
  justify-content: space-between;
}
.blue_toast .toast {
  background-color: #99D6FF;
}
.toast_infos {
  display: flex;
  width: 100%;
}
.toast_icon {
  margin-right: 1rem;
}
.toast_infos span {
  font-family: 'timsans_regular';
  font-size: 0.875em;
  width: 219px;
  line-height: 21px;
}
.toast a {
  margin-top: 12px;
  margin-left: 42px;
  font-family: 'timsans_bold';
  color: #0026D9;
}
.close_toast_icon {
  display: flex;
  width: 16px;
  height: 16px;
  align-items: center;    
  justify-content: flex-end;
  position: absolute;
  right: 0;
  margin-right: 12px;
}
.close_toast_icon img {
  max-width: 9px;
  max-height: 9px;
  box-sizing: border-box;
  cursor: pointer;
}

.no_link .toast_infos{
  align-items: center;
}
/* -------------------------------AC------------------------------- */
.toast_container-ac .toast {
  background: #A09707;
}
.toast_container-ac .toast span {
  color: "#000"
}
</style>